import type { ReactNode } from 'react';

import clsx from 'clsx';

import { twMerge } from '@polyai/ui/utils/twMerge';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const NameWrapper = ({ children, className, ...props }: Props) => {
  return (
    <div
      className={twMerge(
        clsx('flex items-center gap-xs2 select-text z-[20] w-full', className),
      )}
      {...props}
    >
      {children}
    </div>
  );
};
